import { Link } from "react-router-dom";

const css = `
  .legal-page { min-height:100vh; background:var(--bg); padding:48px 24px 80px; }
  .legal-wrap { max-width:720px; margin:0 auto; }
  .legal-logo { font-family:var(--head); font-size:22px; font-weight:800; letter-spacing:2px; margin-bottom:48px; display:inline-block; }
  .legal-logo span { color:var(--blue); }
  .legal-page h1 { font-family:var(--head); font-size:32px; font-weight:800; letter-spacing:2px; margin-bottom:8px; }
  .legal-page .updated { color:var(--muted); font-size:13px; margin-bottom:40px; }
  .legal-page h2 { font-family:var(--head); font-size:16px; font-weight:700; letter-spacing:1px; margin:32px 0 10px; color:var(--blue); text-transform:uppercase; }
  .legal-page p, .legal-page li { font-size:15px; line-height:1.7; color:var(--muted); margin-bottom:12px; }
  .legal-page li { margin-left:20px; list-style:disc; }
  .legal-page a { color:var(--blue); text-decoration:none; }
  .legal-back { display:inline-flex; align-items:center; gap:6px; color:var(--muted); font-size:13px; text-decoration:none; margin-top:40px; }
  .legal-back:hover { color:var(--text); }
`;

export default function Privacy() {
  return (
    <>
      <style>{css}</style>
      <div className="legal-page">
        <div className="legal-wrap">
          <Link to="/" className="legal-logo">NEO<span> DETAIL</span></Link>
          <h1>PRIVACY POLICY</h1>
          <div className="updated">Last updated: May 7, 2026</div>

          <p>This Privacy Policy describes how NEO Detail LLC ("we," "us," or "our") collects, uses, and protects information when you use the NEO Detail platform at neodetail.app.</p>

          <h2>1. Information We Collect</h2>
          <ul>
            <li><strong>Account info:</strong> Your name, email address, business name, phone number, city, and state when you sign up.</li>
            <li><strong>Booking data:</strong> Customer names, emails, phone numbers, vehicle info, and appointment details submitted through your booking page.</li>
            <li><strong>Payment info:</strong> Subscription billing is handled by Stripe — we never store your card number. If you use Stripe Connect, your connected Stripe account ID is stored.</li>
            <li><strong>SMS data:</strong> If you use our SMS feature, customer phone numbers and message content are processed by Twilio for delivery. We log message metadata (recipient, timestamp, delivery status) for usage tracking and support.</li>
            <li><strong>Usage data:</strong> Pages visited, actions taken, and error logs for platform improvement.</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To operate and improve the NEO Detail platform</li>
            <li>To send booking confirmation and status update emails via Resend</li>
            <li>To send SMS notifications via Twilio (only when initiated by you)</li>
            <li>To process subscription payments via Stripe</li>
            <li>To provide customer support</li>
            <li>To comply with legal obligations</li>
          </ul>

          <h2>3. Third-Party Services</h2>
          <p>We use the following third-party services that may process your data:</p>
          <ul>
            <li><strong>Supabase</strong> — database and authentication hosting</li>
            <li><strong>Stripe</strong> — payment processing and subscription management</li>
            <li><strong>Resend</strong> — transactional email delivery</li>
            <li><strong>Twilio</strong> — SMS message delivery (phone numbers and message content are transmitted to Twilio for sending)</li>
            <li><strong>Vercel</strong> — platform hosting and serverless functions</li>
          </ul>
          <p>Each of these services has their own privacy policy governing how they handle data.</p>

          <h2>4. Your Customer Data</h2>
          <p>When your customers book through your NEO Detail booking page, their information is stored in our database on your behalf. You are the data controller for your customers' data. We process it only to operate the Service for you.</p>

          <h2>5. Data Retention</h2>
          <p>We retain your account and booking data for as long as your account is active. If you delete your account, your data is removed within 30 days, except where required by law.</p>

          <h2>6. Security</h2>
          <p>We use industry-standard security practices including encrypted connections (HTTPS), row-level security on our database, and limited access controls. No system is 100% secure — please use a strong password and keep your credentials private.</p>

          <h2>7. Cookies</h2>
          <p>We use minimal cookies necessary for authentication (session tokens). We do not use advertising or tracking cookies.</p>

          <h2>8. Your Rights</h2>
          <p>You may request access to, correction of, or deletion of your personal data at any time by emailing <a href="mailto:support@neodetail.app">support@neodetail.app</a>. We will respond within 30 days.</p>

          <h2>9. Children's Privacy</h2>
          <p>The Service is not directed to children under 13. We do not knowingly collect personal information from children.</p>

          <h2>10. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of material changes by email or through the platform.</p>

          <h2>11. Contact</h2>
          <p>Questions about privacy? Email us at <a href="mailto:support@neodetail.app">support@neodetail.app</a>.</p>

          <Link to="/" className="legal-back">← Back to NEO Detail</Link>
        </div>
      </div>
    </>
  );
}
